import { computed, ref } from 'vue';
import { useEventListener } from '@vueuse/core';

// rounds to nearest millionth, to clean up floating point math
const fix6 = (n: number) => Math.round(n * 1e6) / 1e6;

const step = ref(0);

// text inflation coefficient is sqrt(2)^(step), default is 1 (step 0)
export const textInflation = computed(() =>
  fix6(Math.pow(Math.sqrt(2), step.value))
);

export function initTextInflation() {
  if (import.meta.env.DEV) {
    useEventListener(window, 'keydown', e => {
      if (e.altKey) {
        if (e.code === 'Period') step.value += 1;
        if (e.code === 'Comma') step.value -= 1;
      }
    });
  }
}

export const getTextInflation = () => textInflation.value;

export let inflate = (str: string) => str;

if (import.meta.env.DEV) {
  inflate = str => {
    const v = textInflation.value;
    const sep = step.value === 0 ? '' : ' › ';
    const repeated = (str + sep).repeat(Math.ceil(v));
    const toSlice = Math.ceil(str.length * v) + sep.length * Math.ceil(v - 1);

    let output = repeated.slice(0, toSlice);

    if (v < 1) {
      output += ' ‹';
    }

    return output;
  };
}
